(function () {
  function getRoot(el) { return el.closest("product-info") || document; }

  function parseVariants(root) {
    var script = root.querySelector('variant-radios script[type="application/json"]') ||
                  root.querySelector('variant-selects script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (e) { return []; }
  }

  function initOne(el) {
    var root = getRoot(el);
    var variants = parseVariants(root);
    var variantIdInput = root.querySelector(".product-variant-id");
    var quantityInput = root.querySelector(".quantity__input");
    var lastSignature = null;

    function sellingPlanId() {
      var input = root.querySelector('[name="selling_plan"]') || document.querySelector('[name="selling_plan"]');
      return input && input.value ? String(input.value) : "";
    }

    function currentVariant() {
      var id = variantIdInput ? variantIdInput.value : null;
      if (!id) return variants[0];
      var found = variants.filter(function (v) { return String(v.id) === String(id); })[0];
      return found || variants[0];
    }

    function render() {
      var variant = currentVariant();
      if (!variant) return;
      var planId = sellingPlanId();
      var unitPrice = variant.price;
      if (planId && variant.selling_plan_allocations) {
        var allocation = variant.selling_plan_allocations.filter(function (a) {
          return String(a.selling_plan_id) === planId;
        })[0];
        if (allocation) unitPrice = allocation.price;
      }
      var quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
      var subtotal = unitPrice * quantity;

      var signature = variant.id + "|" + planId + "|" + quantity + "|" + subtotal;
      if (signature === lastSignature) return;
      lastSignature = signature;

      el.textContent = subtotal >= 1500 ? "Free UK delivery" : "Free UK delivery on orders \u00a315+";
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, render);
    }
    if (quantityInput) {
      quantityInput.addEventListener("change", render);
      quantityInput.addEventListener("input", render);
    }
    document.addEventListener("change", function (e) {
      if (e.target && e.target.name === "selling_plan") render();
    });

    // Safety net: the native Subscriptions app block's hidden selling_plan input may not
    // reliably fire a change event we can catch -- a cheap poll guarantees correctness
    // without depending on that app's internal implementation.
    setInterval(render, 400);

    render();
  }

  function init() {
    var els = document.querySelectorAll("[data-zh-free-delivery]");
    for (var i = 0; i < els.length; i++) initOne(els[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();